module.exports = __webpack_public_path__ + "assets/img/The Star Vista.5e91a147.jpg";